import { cn } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { HISTORY_AMOUNT_COL, HISTORY_TIME_COL } from './HistoryRow'

/** Заголовки колонок «Расхода» — на тех же ширинах, что и строки (миниатюра + стрелка учтены). */
export const HistoryHeader = () => {
  const m = useMessages(messages)
  return (
    <div className="flex items-center gap-3 border-b border-foreground/5 px-2 pb-3 text-xs text-muted-foreground sm:gap-4">
      <span className="min-w-0 flex-1">{m.colRun}</span>
      <span className={HISTORY_TIME_COL}>{m.colTime}</span>
      <span className={cn(HISTORY_AMOUNT_COL, 'pr-5')}>{m.colSpent}</span>
      <span className="size-4 shrink-0" />
    </div>
  )
}
